import { j as f } from "./jsx-runtime.DGlMoOmv.js";
import * as e from "react";
const c = ({
  isMounted: t,
  delay: s = 300,
  children: a,
  onUnmountChildren: l
}) => {
  const [r, u] = e.useState(t), n = e.useRef(!0);
  return e.useEffect(() => {
    let o;
    return t ? u(!0) : o = setTimeout(() => {
      u(!1);
    }, s), () => {
      clearTimeout(o);
    };
  }, [t, s]), e.useEffect(() => {
    n.current = !1, !r && !n.current && l?.();
  }, [r]), r ? /* @__PURE__ */ f.jsx(f.Fragment, { children: a }) : null;
};
export {
  c as D
};
//# sourceMappingURL=DelayedUnmount.DcDPayfx.js.map
